/* eslint-disable */
/* @flow */

import React, {Component} from 'react'

import styles from './Styles/TermCellStyles'

import { View, Text, StyleSheet } from 'react-native';

import I18n from "i18n-js"

// create a component
class TermsCell extends Component {
    render() {
        return (
            <View style={styles.container}>
            <Text style={styles.text}>{I18n.t('signUp.agreeTerm')}</Text>
            <Text
              onPress={this.props.onLinkPress}
              style={[
                  styles.text,
                  styles.link,
              ]}>{I18n.t('signUp.agreeConditions')}</Text>
          </View>
        );
    }
}

export default TermsCell
